import { render, staticRenderFns } from "./BootStrapTableSample.vue?vue&type=template&id=87376f2c&scoped=true"
import script from "./BootStrapTableSample.vue?vue&type=script&lang=js"
export * from "./BootStrapTableSample.vue?vue&type=script&lang=js"
import style0 from "./BootStrapTableSample.vue?vue&type=style&index=0&id=87376f2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87376f2c",
  null
  
)

export default component.exports